<template>
    <div>
        <BCard no-body class="mb-0">
            <TableFilters :vsPerPage="perPage" :vsPageOptions="perPageOptions" :vsSearchQuery="searchQuery" vsLabel="Add cash" vsModule="cash" vsRoute="cash-add" />

            <BTable ref="cashTable" class="position-relative" :items="fetchCash" responsive :fields="tableColumns" primary-key="id" :sort-by.sync="sortBy" show-empty :empty-text="$t('No match records found')" :sort-desc.sync="isSortDirDesc">
                <template #cell(name)="data">
                    <BLink :to="{ name: 'cash-view', params: { id: data.item.id } }"> {{ data.item.name }} </BLink>
                </template>
                <template #cell(balance)="data">
                    <!-- <span v-if="data.item.total">{{ data.item.balance + data.item.total }}€</span> -->
                    <span v-if="data.item.total">{{ formatCurrency(parseFloat(data.item.total)) }}</span>
                    <span v-else> - </span>
                </template>
                <template #cell(total)="data">
                    {{ formatCurrency(data.item.balance) }}
                </template>
                <template #cell(group)="data" v-if="ability.can('read', 'group')">
                    <BLink :to="{ name: 'groups-view', params: { id: data.item.group.id } }"> {{ data.item.group.name }} </BLink>
                </template>
                <template #cell(group)="data" v-else>
                    <span>{{ data.item.group.name }}</span>
                </template>
                <template #cell(actions)="data">
                    <BDropdown variant="link" no-caret>
                        <template #button-content>
                            <FeatherIcon icon="MoreVerticalIcon" size="16" class="align-middle text-body" />
                        </template>
                        <BDropdownItem :to="{ name: 'cash-view', params: { id: data.item.id } }" v-if="ability.can('read', 'cash')">
                            <FeatherIcon icon="FileTextIcon" />
                            <span class="align-middle ml-50">{{$t('Details')}}</span>
                        </BDropdownItem>

                        <BDropdownItem :to="{ name: 'cash-edit', params: { id: data.item.id } }" v-if="ability.can('write', 'cash')">
                            <FeatherIcon icon="EditIcon" />
                            <span class="align-middle ml-50">{{$t('Edit')}}</span>
                        </BDropdownItem>

                        <BDropdownItem @click="deletePopup(data.item.id, 'cashes/deleteCash')" v-if="ability.can('delete', 'cash')">
                            <FeatherIcon icon="TrashIcon" />
                            <span class="align-middle ml-50">{{$t('Delete')}}</span>
                        </BDropdownItem>

                        <!-- <BDropdownItem @click="exportMovements(data.item.id)">
                            <FeatherIcon icon="FileIcon" />
                            <span class="align-middle ml-50">Exportar movimientos</span>
                        </BDropdownItem> -->
                    </BDropdown>
                </template>
            </BTable>

            <TablePagination :vsEntries="dataMeta" :vsCurrent="currentPage" :vsPerPage="perPage" :vsTotal="totalCash" />
        </BCard>
    </div>
</template>
<script>
import { BCard, BDropdown, BDropdownItem, BLink, BRow, BTable } from 'bootstrap-vue';
import { onUnmounted } from '@vue/composition-api';
import TablePagination from '@/components/list/TablePagination.vue';
import TableFilters from '@/components/list/TableFilters.vue';
import cashListQuery from './cashListQuery';
import ability from '@/libs/acl/ability';
import cashModule from '../cashModule';
import popups from '@/hooks/popups';
import store from '@/store';
import axios from '@axios';
import currency from '@/utils/currency'

export default {
    components: { BCard, BRow, TablePagination, TableFilters, BTable, BLink, BDropdown, BDropdownItem },
    setup(){
        const { formatCurrency } = currency()
        const { deletePopup, successToast, errorToast } = popups()
        const { fetchCash, tableColumns, perPage, currentPage, totalCash, dataMeta, perPageOptions, searchQuery, sortBy, isSortDirDesc, cashTable, refetchData, groupFilter, groupOptions } = cashListQuery()
        const CASH_MODULE = 'cashes'

        if(!store.hasModule(CASH_MODULE)){
            store.registerModule(CASH_MODULE, cashModule)
        }

        onUnmounted(() => {
            if(store.hasModule(CASH_MODULE)) {
                store.unregisterModule(CASH_MODULE)
            }
        })

        /**
         * Exportar movimiento en CSV
         */
        const exportMovements = function(id){
            axios.post('movements/export', { id: id }).then(response => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'listadoMovimientos.csv');
                document.body.appendChild(fileLink);
                fileLink.click();
                successToast('CSV descargado')            
            })
            .catch(error => {
                errorToast('No ha sido posible descargar el CSV: ', error)
            })
        }

        return {
            fetchCash,
            tableColumns,
            perPage,
            currentPage,
            totalCash,
            dataMeta,
            perPageOptions,
            searchQuery,
            sortBy,
            isSortDirDesc,
            cashTable,
            refetchData,
            groupFilter,
            groupOptions,
            ability,
            deletePopup,
            exportMovements,
            formatCurrency
        }
    }
}
</script>
